import React from 'react';
import {Route, IndexRoute} from 'react-router';

import App from './containers/App';
import HomePage from './containers/HomePage';
import Surgery from './containers/Surgery';
import Doctors from './containers/Doctors';
import DoctorDetail from './containers/DoctorDetail';
import Partners from './containers/Partners';
import Pricing from './containers/Pricing';
import Procedure from './containers/Procedure';
import Gallery from './containers/Gallery';
import Contact from './containers/Contact';
import Forum from './containers/Forum';
import ForumFrom from './containers/ForumForm';

export default (
  <Route path="/" component={App}>
    <IndexRoute component={HomePage}/>
    <Route path="/cs" component={HomePage} />
    <Route path="/zakroky" component={Surgery} />
    <Route path="/lekari" component={Doctors} />
    <Route path="/lekar/:doctor" component={DoctorDetail} />
    <Route path="/partneri" component={Partners} />
    <Route path="/cenik" component={Pricing} />
    <Route path="/zakrok/:surgery/:procedure" component={Procedure} />
    <Route path="/galerie" component={Gallery} />
    <Route path="/kontakt" component={Contact} />
    <Route path="/poradna" component={Forum} />
    <Route path="/poradna/dotaz" component={ForumFrom} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js